import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { Select } from 'antd';

export interface IProductTagSelectProps extends RouteComponentProps<{ eshop: string }> {
  name: string;
  value: string[] | undefined;
  tags?: Array<GQL.IProductTag>;
  style?: any;
  onChange: (e: any) => void;
}

class ProductTagSelectControl extends React.PureComponent<IProductTagSelectProps> {

  constructor(props: IProductTagSelectProps) {
    super(props);

    this.onChange = this.onChange.bind(this);
  }

  public render() {
    const { value, style, tags } = this.props;

    if (tags) {
      return (
        <Select
          mode="tags"
          defaultValue={value}
          style={{ width: '100%', ...style }}
          placeholder={'Choose tags'}
          onChange={(newTags: string[]) => this.onChange(newTags)}
        >
          {tags &&
            tags.map((t: GQL.IProductTag) => (
              <Select.Option key={t.id} value={t.id} style={{ position: 'relative', backgroundColor: t.color || 'transparent', color: '#FFF' }}>
                <span style={{ zIndex: 2, position: 'relative', color: '#FFF', fontSize: '90%', fontWeight: 500 }}>{t.name}</span>
                <span style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: t.color || 'transparent', color: '#FFF' }} />
              </Select.Option>
            ))}
        </Select>
      );
    }

    return null;
  }

  private onChange(value: string[]) {
    if (this.props.onChange) {
      this.props.onChange({
        target: {
          name: this.props.name,
          value,
        }
      });
    }
  }
}

export default ProductTagSelectControl;


// WEBPACK FOOTER //
// ./src/components/Others/ProductTagSelect/ProductTagSelect.tsx